import { COMMON_LANGUAGES } from '@sdbn/common';

export class DefaultSettings {

  public static get(tmcBaseUrl: string, tmcClientUrl: string) {
    return {

      tmcBaseUrl: tmcBaseUrl,
      tmcClientUrl: tmcClientUrl,

      autoreload: true,

      languageOptions: [
        COMMON_LANGUAGES.find(l => l.key === 'de')!,
        COMMON_LANGUAGES.find(l => l.key === 'en')!,
        COMMON_LANGUAGES.find(l => l.key === 'fr')!,
        COMMON_LANGUAGES.find(l => l.key === 'it')!
      ],

      enableLogging: true,
      simulatorAvailable: true,
    };
  }
}
